export const SET_FILTER = 'SET_FILTER';
export const RESET_FILTERS = 'RESET_FILTERS';
export const SET_PAGINATION_ITEM = 'SET_PAGINATION_ITEM';
export const RESET_SET_FILTER_HAS_CHANGED = 'SET_FILTER_HAS_CHANGED';
export const SET_FILTERS_HAS_RESETED = 'SET_FILTERS_HAS_RESETED';
export const SET_TAB_ACTIVE_BY_PAGE = 'SET_TAB_ACTIVE_BY_PAGE';
export const SET_IMAGES_BENCH_FILTER = 'SET_IMAGES_BENCH_FILTER';
